var partners = new function () {

    this.xhr;
    this.data;
    this.grid;

    this.concatValues = function(obj) {
        var value = '';
        for (var prop in obj) {
            value += obj[prop];
        }
        return value;
    }
}

jQuery(document).ready(function ($) {

    AOS.init({
        duration: 750
    });

    $(document).on('mouseover', '.blocked-countries-list', function(e) {
        e.preventDefault();

        var data = $(this).data('country-list');

        $(this).attr('content', data);
    });

    // init Isotope
    var defaultFilter = $('.partners__filters').data('default');
    $grid = $('.grid').isotope({
        itemSelector: '.grid-item',
        stagger: 30,
        transitionDuration: 300,
        filter: defaultFilter
    });

    // store filter for each group
    var filters = {};

    $(document).on('click', '.partners__filters button', function(event) {
        var $button = $(event.currentTarget);
        // get group key
        var $buttonGroup = $button.parents('.button-group');
        var filterGroup = $buttonGroup.attr('data-filter-group');
        // set filter for group
        filters[filterGroup] = $button.attr('data-filter');
        // combine filters
        var filterValue = partners.concatValues(filters);
        // set filter for Isotope
        $grid.isotope({ filter: filterValue });
    });

    $('.partners__filters').find('button[data-filter="' + defaultFilter + '"]').addClass("is-checked");

    // change is-checked class on buttons
    $('.button-group').each(function (i, buttonGroup) {
        var $buttonGroup = $(buttonGroup);
        $buttonGroup.on('click', 'button', function (event) {
            $buttonGroup.find('.is-checked').removeClass('is-checked');
            var $button = $(event.currentTarget);
            $button.addClass('is-checked');
        });
    });
});

jQuery(window).resize(function() {
    if ($('.partners-container').length) {
        var initialHeight = $('.partners').css('height');
        $('.partners-container').css('min-height', initialHeight);
    }
});